
  import CodeMirror from "/lib/CodeMirror.js"
  document.addEventListener("DOMContentLoaded", ()=>{
    // window.codemirror = new CodeMirror(document.querySelector("#editeur"));})
    window.codemirror = new CodeMirror(window.shadow.querySelector("#editeur"));})
